module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "menu"
  }, [_vm._v("\n    Oh noes! You're out of taps.\n    "), _c('h1', [_vm._v(_vm._s(_vm.score))]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$emit('retry')
      }
    }
  }, [_vm._v("Try again")]), _vm._v(" "), (_vm.runningInApp && !_vm.alreadyRewarded) ? _c('button', {
    on: {
      "click": _vm.getExtraClicks
    }
  }, [_c('i', {
    staticClass: "fa fa-film",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get extra taps!")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "button blue",
    attrs: {
      "to": {
        'name': 'start'
      },
      "replace": ""
    }
  }, [_vm._v("Main menu")]), _vm._v(" "), _c('div', {
    staticClass: "ads"
  }, [_c('ins', {
    staticClass: "adsbygoogle",
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "data-ad-client": "ca-pub-9072364747594224",
      "data-ad-slot": "3124355986",
      "data-ad-format": "auto"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-003d5192","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RetryMenu.vue
// module id = 106
// module chunks = 1